import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const GsisPAInvitationCallback = () => {
  if (import.meta.env.MODE === "development") {
    window.serverData = {
      status: "success",
      data: {
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxNTczMTUxNzciLCJ1c2VyX2lkIjoiMTBlZDQ0NzAtNjZhZS00ODBjLTliM2YtZTE2YjMyYjQ3MWY3IiwibmJmIjoxNzY0ODQzNjczLCJleHAiOjE3NjQ4NDM5NzMsImlhdCI6MTc2NDg0MzY3M30.vEChbIv6C5duZoqXZGfeAhoLNAqjf3gJa4PSq7_Ej5I",
      },
    };
  }

  const [data] = useState(window.serverData || {});
  const navigate = useNavigate();

  useEffect(() => {
    if (data.status === "success") {
      navigate("/pa-employee-amka-login");
    } else {
      navigate("/error");
    }
  }, [data]);

  return (
    <div>
      <p>Processing, please wait...</p>
    </div>
  );
};

export default GsisPAInvitationCallback;
